import { useEffect } from 'react';

/**
 * Paints the <body> background so overscroll (rubber-banding past the top/bottom
 * of the page's scroll container) reveals the resolved page background color —
 * custom or default — instead of the browser's default white body. The previous
 * value is restored on unmount so this page's color doesn't leak onto other pages.
 *
 * `undefined` leaves the <body> untouched — for callers whose page renders inside a container
 * (the collection link editor's inline edit canvas) where the body is never visible and painting
 * it would be a document-level leak.
 */
export const useBodyBackground = (color: string | undefined) => {
  useEffect(() => {
    if (color === undefined) {
      return;
    }

    const previousBackgroundColor = document.body.style.backgroundColor;

    document.body.style.backgroundColor = color;

    return () => {
      document.body.style.backgroundColor = previousBackgroundColor;
    };
  }, [color]);
};
